import React from 'react'

// Mobile-first: 2 cols at xs, 3 at sm, 4 at md+. Each tile is a button.
export default function CategoryPicker({ categories, selected, onSelect }) {
  return (
    <div className="row g-2">
      {categories.map(c => {
        const active = selected === c.cat_id
        return (
          <div key={c.cat_id} className="col-6 col-sm-4 col-md-3">
            <button
              type="button"
              onClick={() => onSelect(c.cat_id)}
              className={
                'btn w-100 h-100 d-flex flex-column align-items-center justify-content-center text-center p-2 ' +
                (active ? 'btn-primary' : 'btn-outline-secondary')
              }
              style={{ minHeight: 90 }}
            >
              <i className={`${c.cat_icon || 'ri-tools-line'} fs-3 mb-1`} />
              <span className="small lh-sm">{c.cat_name}</span>
              {!active && (
                <span className="text-muted" style={{ fontSize: 10 }}>
                  → {c.cat_allow_dept_select ? 'เลือกฝ่ายเอง' : c.default_dept_name}
                </span>
              )}
            </button>
          </div>
        )
      })}
    </div>
  )
}
